<div class="mx-0 my-auto w-100 p-5 d-flex justify-content-center align-items-center flex-column">
  <textarea class="form-control w-750" rows="10" [(ngModel)]="movies"></textarea>
  <button class="btn btn-success btn-lg w-25 mt-5" (click)="submit()"> SUBMIT </button>
</div>